import { scrollWindowToElement } from 'scroll-element'
import { isEmpty, isNull } from '~/misc/utils'

export default class About {
    constructor() {
        this.cacheDom()
        this.inizialize()
    }

    cacheDom() {
        this.header = document.querySelector('.site-header')
    }

    inizialize() {
        const hash = window.location.hash.substr(1)

        if (!isEmpty(hash)) {
            window.scrollTo(0, 0)
            setTimeout(() => {
                window.scrollTo(0, 0)
            }, 1)

            const anchorEl = document.getElementById(hash)

            if (!isNull(anchorEl)) {
                const offset = this.header.offsetHeight + 20
                scrollWindowToElement(anchorEl, 500, -offset)
            }
        }
    }
}
